import React, { Component } from 'react';
import { Field, FieldArray } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterQuery from './FilterQuery';

import {
  CheckboxField,
} from '../../../form';

const filterBoxStyles = {
  border: '1px solid rgba(132, 132, 132, 0.52)',
  boxSizing: 'border-box',
  padding: '20px 0px 5px 0px',
  position: 'relative'
};

const filterQueryStyles = {
  borderRadius: '50%',
  backgroundColor: 'red',
  color: 'white',
  padding: '2px 7px',
  border: '0px',
  position: 'absolute',
  top: '-10px',
  right: '-10px'
};

const renderFilters = ({ fields }) => (
  <div>
    {
      fields.map((filter, index) => {
        return (
          <div key={index}>
            <div
              id='filter-0'
              style={filterBoxStyles}
            >
              <button type="button" onClick={() => fields.remove(index)} style={filterQueryStyles}>
                <FontAwesomeIcon icon='times' />
              </button>
              <FieldArray name={`${filter}.or`} component={FilterQuery} />
            </div>
            {
              fields.length > index + 1 && (
                <div style={{ margin: '10px 0 10px 0' }} className='noselect'>AND</div>
              )
            }
          </div>
        );
      })
    }
    <div style={{ textAlign: 'center', margin: '25px 0px' }}>
      <Button
        bsSize='lg'
        onClick={() => fields.push({ or: [{ term: { field: '', operator: '', value: null } }] })}
        bsStyle='success'
        className='m-l-xs'
        style={{ marginBottom: '10px' }}
      >
        AND
      </Button>
    </div>
  </div>
);

class FeedFilters extends Component {
  render() {
    const { useFilters } = this.props;

    return (
      <div>
        <p>
          By default all ads are indexed from a feed. By enabling <strong>and</strong> creating filters, 
          all ads that pass the filters will be included.
        </p>
        <Field
          name='filter'
          label='Enable Filters'
          type='checkbox'
          singleLine
          component={CheckboxField}
        />

        <div className={!useFilters && 'disabled'}>
          <FieldArray name={'and'} component={renderFilters} />
        </div>
      </div>    
    );
  }
}

export default (FeedFilters);
